import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import useCatalogData from "@/hooks/useCatalogData";
import { CATEGORY_RESET_FIELDS, initialFormState, computeFlags } from "@/lib/catalogMeta";
import { buildValuationPayload } from "@/lib/valuationPayload";

export default function useValuatorForm() {
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState(() => initialFormState(searchParams));
  const { categories, brands, models, modelMeta, setModels } = useCatalogData(form, setForm);

  const update = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const onCategoryChange = (value) => {
    setForm((p) => ({ ...p, category: value, ...CATEGORY_RESET_FIELDS }));
    setModels([]);
  };

  const onBrandChange = (value) => {
    setForm((p) => ({ ...p, brand: value, model: "", model_custom: "" }));
  };

  const flags = computeFlags(form, brands, models);

  const buildPayload = (photoPaths, lang) => buildValuationPayload(form, flags, photoPaths, lang);

  return {
    form, update, onCategoryChange, onBrandChange,
    categories, brands, models, modelMeta,
    ...flags,
    buildPayload,
  };
}
